import { cn } from '../../../lib/cn'
import type { ResumoChamado } from '../../../types/chamado'
import { COLUNAS, DESCRICAO_DA_LISTA } from './colunas'
import { LinhaDeChamado } from './LinhaDeChamado'

/**
 * A listagem em tabela.
 *
 * Tabela de verdade, com `<th scope="col">`, e não uma grade de `<div>`: é o que permite ao leitor
 * de tela anunciar "Prazo: prazo estourado" ao entrar na célula, em vez de ler uma sequência de
 * textos soltos. Numa tela cujo assunto é conferir número contra documento assinado, saber a qual
 * coluna o valor pertence é a informação, não um detalhe de acessibilidade.
 *
 * Sem cabeçalho fixo ao rolar, pela mesma razão da listagem de GMUD: a barra superior é `sticky` e
 * tem altura própria, então um `<th>` grudado no topo precisaria repetir aqui a altura dela em
 * pixels — número que envelhece na primeira vez que alguém mexer na barra, e cujo sintoma é o
 * cabeçalho desaparecendo por baixo dela, sem erro e sem teste.
 *
 * @param props as linhas da página corrente
 * @returns a tabela
 */
export function TabelaDeChamados({ itens }: { itens: ResumoChamado[] }) {
  return (
    <div className="cartao overflow-hidden">
      {/* A rolagem lateral fica NESTA caixa, nunca na página: tabela larga que empurra o `<body>`
          faz o menu e o cabeçalho andarem junto, e aí a tela inteira parece torta. */}
      <div className="overflow-x-auto">
        <table className="min-w-full text-left">
          <caption className="sr-only">{DESCRICAO_DA_LISTA}</caption>
          <thead>
            <tr className="border-b border-slate-200 bg-slate-50">
              {COLUNAS.map((coluna) => (
                <th
                  key={coluna.id}
                  scope="col"
                  className={cn(
                    'cabecalho-de-coluna',
                    coluna.classe,
                  )}
                >
                  {coluna.titulo}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {itens.map((chamado) => (
              <LinhaDeChamado key={chamado.id} chamado={chamado} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
